import { useRef, useState } from "react"
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler"
import { Dropdown } from "react-bootstrap"
import { DropdownItemWithActions } from "./DropdownItemWithActions"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FilterPagination } from "./FIlterPagination"

export const ManageListDropdown = ({
    heading,
    setHeading,
    categories,
    onEdit,
    onDelete,
    onUpdate,
    storageKey,
    setTempFilterData,
    staticOptions,
    filterOffset,
    setFilterOffset,
    handleFilterPageChange,
    filterPageCount,
    filterLimit
}) => {
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState("")
    const ref = useRef()

    useOutsideClickHandler({
        objRef: ref,
        isDropdown: open,
        setDropdown: setOpen
    })

    const filtered = !search
        ? categories
        : categories.filter(c =>
            c.card_name.toLowerCase().includes(search.toLowerCase())
        )

    const handleSelect = (value) => {
        setHeading(value)
        localStorage.setItem(storageKey, value)
        setOpen(false)
    }

    return (
        <Dropdown show={open} ref={ref}>
            <i
                className="fa-solid fa-caret-down"
                style={{ fontSize: "1rem", height: "0rem" }}
                onClick={() => setOpen(!open)}
            />

            <Dropdown.Menu
                className="main-header-dropdown header-profile-dropdown dropdown-menu-start"
                style={{
                    top: "3.2rem !important",
                    width: "auto",
                    minWidth: "20rem",
                    marginTop: "18px",
                    marginLeft: "0rem",
                    zIndex: 1,
                    padding: 0,
                }}
            >
                <div className="d-flex justify-content-between gap-5" style={{ margin: " 0px 17px " }}>
                    <div
                        className="mb-2 mt-3 fw-bold "
                        style={{ textWrap: "nowrap" }}
                    >
                        Manage List
                    </div>
                    {/* Search */}
                    <div className=" position-relative align-self-end">
                        <input
                            type="text"
                            value={search}
                            style={{
                                fontSize: "12px",
                                paddingLeft: "35px",
                                width: "150px",
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                            className="form-control"
                            placeholder="Search Here..."
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                }
                            }}
                        />
                        <i
                            class="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                marginLeft: "13px",
                            }}
                        ></i>
                        {search && search.length > 0 && (
                            <i
                                className="fa-solid fa-xmark"
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: 0,
                                    marginRight: "13px",
                                    cursor: "pointer",
                                }}
                                onClick={() => setSearch("")}
                            />
                        )}
                    </div>
                </div>

                {/* static options for respective module will be provided by module itself and mapped here */}
                {staticOptions && staticOptions?.map((item) => (
                    <Dropdown.Item key={item} onClick={() => handleSelect(item.key)}>
                        {item?.icon}
                        {item?.key}
                    </Dropdown.Item>
                ))}

                {/* dynamic options filters created by the user will be mapped below */}
                {filtered?.length > 0 ?
                    <>
                        {filtered?.map((category) => (
                            <DropdownItemWithActions
                                key={category.id}
                                title={category.card_name}
                                onClickMain={() => {
                                    handleSelect(category.card_name)
                                    setTempFilterData(null)
                                }}
                                icon={faUser}
                                onEdit={() => onEdit(category)}
                                onDelete={() => onDelete(category)}
                                onUpdate={() => onUpdate(category)}
                            />
                        ))}
                        <div className="p-2">
                            <FilterPagination
                                offset={filterOffset}
                                setOffset={setFilterOffset}
                                handlePageChange={handleFilterPageChange}
                                pageCount={filterPageCount}
                                limit={filterLimit}
                            />
                        </div>
                    </>
                    :
                    (
                        search &&
                        search.trim() !== "" && (
                            <Dropdown.Item className="text-muted text-center py-3">
                                <small>No filters found</small>
                            </Dropdown.Item>
                        )
                    )
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}